module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }